import useFacebookPixel from './useFacebookPixel'
import useGoogleTagManager from './useGoogleTagManager'

const useTracking = () => {
    useGoogleTagManager()
    useFacebookPixel()
}

export default useTracking
